<div class="wrapper">
  <div class="headers" [class.disabled]="!isAuthCanWrite">
    <div class="list-header">
      <div class="sub-title" i18n="@@general.contacts">Contacts</div>
      <div
        class="action-btn"
        (click)="onAddContactBtn()"
        [hidden]="addNewContactScreenActive"
      >
        <mat-icon class="material-icons-outlined">add</mat-icon>
        <span i18n="@@general.contacts.buttons.addcontact">add contact</span>
      </div>
    </div>

    <div class="list-header" *ngIf="showTabContent">
      <div class="sub-title" i18n="@@general.contactinfo">Contact info</div>
      <div class="button-list">
        <div class="action-btn" (click)="saveContact()">
          <mat-icon class="material-icons-outlined">save</mat-icon>
          <span i18n="@@general.contacts.buttons.save">save</span>
        </div>
        <div
          class="action-btn"
          (click)="deleteContact()"
          *ngIf="!addNewContactScreenActive; else cancelNew"
        >
          <mat-icon class="material-icons-outlined">delete</mat-icon>
          <span i18n="@@general.contacts.buttons.delete">delete</span>
        </div>
        <ng-template #cancelNew>
          <div class="action-btn" (click)="cancelNewContact()">
            <mat-icon class="material-icons-outlined">cancel</mat-icon>
            <span i18n="@@general.contacts.buttons.cancel">cancel</span>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
  <div class="tabs-wrapper">
    <app-survey-frame-list>
      <app-survey-frame-tab-template
        #tabs
        [headerTemplate]="headerTemplate"
        [bodyTemplate]="bodyTemplate"
        [contexts]="contexts"
        headerWidth="40%"
        bodyWidth="55%"
      ></app-survey-frame-tab-template>
    </app-survey-frame-list>
  </div>
</div>
<ng-template
  #headerTemplate
  let-noContacts="noContacts"
  let-contact="contact"
  let-newContact="newContact"
>
  <div
    *ngIf="noContacts"
    class="contact"
    style="color: #fc7171"
    i18n="@@general.contacts.nocontacts"
  >
    No contacts
  </div>
  <div *ngIf="newContact" class="contact">
    <app-contact-search
      (selectResult)="onSelectSearchResult($event)"
      (newContact)="onNewContact()"
    ></app-contact-search>
  </div>
  <div
    *ngIf="contact && !newContact"
    class="contact"
    (click)="toggleNewContact(false)"
  >
    {{ contact.name }} - <strong>{{ contact.personType }}</strong>
  </div>
</ng-template>
<ng-template
  #bodyTemplate
  let-noContacts="noContacts"
  let-contact="contact"
  let-newContact="newContact"
>
  <ng-container *ngIf="showTabContent">
    <app-contact-form
      #contactRef
      (addNewContactToList)="onAddNewContactToList($event)"
      (editContact)="onEditContact($event)"
      (removeContactFromList)="onRemoveFromListContact($event)"
      [selectedContact]="contact"
      [isSearch]="newContact"
      [isAuthCanWrite]="isAuthCanWrite && !(newContact && !!contact?.id)"
    ></app-contact-form>
  </ng-container>
</ng-template>
